var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccommodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.524,
    height: 16.355,
    viewBox: "0 0 17.524 16.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ion-home",
    "data-name": "Icon ion-home",
    transform: "translate(-1.125 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36870",
    "data-name": "Trac\\xE9 36870",
    d: "M11.709,7.046a.292.292,0,0,0-.4,0L4.584,13.467a.292.292,0,0,0-.09.211V19.7a1.168,1.168,0,0,0,1.168,1.168H9.17a.584.584,0,0,0,.584-.584V15.323a.292.292,0,0,1,.292-.292h2.921a.292.292,0,0,1,.292.292v4.965a.584.584,0,0,0,.584.584H17.35A1.168,1.168,0,0,0,18.518,19.7V13.678a.292.292,0,0,0-.09-.211Z",
    transform: "translate(-1.619 -2.267)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36871",
    "data-name": "Trac\\xE9 36871",
    d: "M18.463,10,15.732,7.383V3.418a.584.584,0,0,0-.584-.584H13.4a.584.584,0,0,0-.584.584V4.586L10.7,2.565a1.2,1.2,0,0,0-1.618,0L1.313,9.994a.6.6,0,0,0-.049.817.584.584,0,0,0,.846.039L9.686,3.611a.292.292,0,0,1,.4,0l7.576,7.239a.584.584,0,0,0,.825-.016A.6.6,0,0,0,18.463,10Z",
    fill: "#ebdcbd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccommodation);
export default __webpack_public_path__ + "static/media/accommodation.cfb21493d0380b1b9fd50ab5b30f5183.svg";
export { ForwardRef as ReactComponent };